import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {Location} from "@angular/common";
import {DeploymentWorkflowService} from "./deployment-workflow.service";
import {WorkflowStep} from "../workflow-step";

@Component({
  templateUrl: "./message-to-transition-leads.template.pug",
  providers: [DeploymentWorkflowService],
})

export class MessageToTransitionLeadComponent extends WorkflowStep {
  public projectId: string;
  public message: string;
  public error: Error;
  public sent: boolean;
  public deals: string[] = [];
  public deploymentId: string;
  public assetIds: any[] = [];
  public workflowId: string;
  public assets: any[] = [];
  public loadScreen: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deploymentWorkflowService: DeploymentWorkflowService,
    public location: Location,
  ) {
    super();
  }

  ready(): void {
    this.projectId = this.workflowService.workflowConfig.projectId;
    this.deploymentId = this.workflowService.workflowConfig.targetId;
    this.workflowId = this.workflowService.workflowConfig.id;

    // Extract asset IDs from query parameters
    this.route.queryParams.subscribe(params => {
      if (params['assetIds']) {
        this.assetIds = params['assetIds'].split(',');
      }
    });
    this.loadData();
    this.loading = false;
  }

  loadData(): void {
    // Don't really need anything here.
  }

  send(): void {
    this.error = null;
    this.sent = false;
    this.loadScreen = true;

    this.deploymentWorkflowService.messageToTransitionLeads(
      this.message,
      this.projectId,
      this.deploymentId,
      this.assetIds,
      this.workflowId,
    )
      .toPromise()
      .then(
        ({success, updatedAssets}) => {
          this.sent = success;
          this.assets = updatedAssets;
          this.loadScreen = false;
        },
        (error) => { this.error = error; this.loadScreen = false; },
      );
  }

  cancel(): void {
    this.location.back();
  }
}
